import type { ReactNode } from 'react';

export interface OrgPickerMembership {
  org_id: string;
  org_name: string;
  function_role_name: ReactNode | null;
}

export interface OrgPickerListProps {
  memberships: ReadonlyArray<OrgPickerMembership>;
  onPick: (membership: OrgPickerMembership) => void;
  disabled?: boolean;
}

/**
 * Inline org-picker used post-password-reset for multi-org users. Each row
 * shows org name + function role; clicking it sets active_org and navigates.
 *
 * Lives in src/components/auth/ rather than src/components/primitives/ because
 * the data shape (memberships + function-role copy) carries product semantics.
 * Visual shape is built from tokens + primitives.css `.pn-org-picker-*` rules.
 */
export function OrgPickerList({ memberships, onPick, disabled }: OrgPickerListProps) {
  return (
    <ul className="pn-org-picker" role="list">
      {memberships.map((m) => (
        <li key={m.org_id} className="pn-org-picker-item">
          <button
            type="button"
            className="pn-org-picker-row"
            onClick={() => onPick(m)}
            disabled={disabled}
          >
            <span className="pn-org-picker-name">{m.org_name}</span>
            {m.function_role_name ? (
              <span className="pn-org-picker-role">{m.function_role_name}</span>
            ) : null}
          </button>
        </li>
      ))}
    </ul>
  );
}
